import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Chart from "react-apexcharts";
import t from "../../../languages/pl";
import withTheme from "@material-ui/core/styles/withTheme";
import { capitalizeFirstLetter, themeTypeToBool } from '../../../utils/helpers';
import './chart.scss';
import { getLastAverage, setGradeColor } from './../../../utils/helpers';
import pl from "apexcharts/dist/locales/pl.json";

const values = (data) => [
    {
        name: t.ecoGradeForFleet,
        type: 'scatter',
        data: data.map(point => ({
            x: point.data,
            y: point.eco
        }))
    },
    {
        name: t.average,
        type: 'line',
        data: data.map(point => {
            return {
                x: point.data,
                y: point.srednia_eco
            };
        })
    }
];

const ColumnChart = ({ theme, data }) => {

    useEffect(() => {
        let elements = document.getElementsByClassName('apexcharts-menu');
        let array = Array.from(elements);
        array.forEach(element => {
            element.classList.add(themeTypeToBool(theme.palette.type) ? "toolbar-light" : "toolbar-dark");
        });
    }, );

    const options = {
        chart: {
            height: 350,
            type: 'line',
            locales: [pl],
            defaultLocale: 'pl',
        },
        stroke: {
            width: [0, 4]
        },
        colors: ['#2E93fA', setGradeColor(getLastAverage(data))],
        dataLabels: {
            enabled: true,
            enabledOnSeries: [1],
            formatter: function(value, { dataPointIndex }) {
                if(dataPointIndex%2 === 0)
                    return value;
                return;
            }
        },
        fill: {
            type: ["solid", "gradient"],
            gradient: {
                shade: "dark",
                type: "horizontal",
            }
        },
        markers: {
            size: [6, 0]
        },
        legend: {
            show: true,
            labels: {
                colors: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                show: true,
                rotate: -45,
                rotateAlways: true,
                // formatter: function (value, timestamp) {
                //     return moment(timestamp).format("DD.MM");
                // },
                datetimeUTC: false,
                datetimeFormatter: {
                    month: "dd.MM",
                    day: "dd.MM",
                },
                style: {
                    colors: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
                }
            },
            title: {
                text: capitalizeFirstLetter(t.days),
                offsetX: 400,
                offsetY: 20,
                style: {
                    color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
                }
            }
        },
        yaxis: {
            type: "numeric",
            show: true,
            min: 0,
            max: 11,
            title: {
                text: t.ecoGradeForFleet,
                style: {
                    color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
                }
            },
            labels: {
                show: true,
                align: 'right',
                style: {
                    colors: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
                }
            }
        },
        tooltip: {
            enabled: true,
            theme: themeTypeToBool(theme.palette.type) ? 'light' : 'dark',
            x: {
                show: true,
                format: 'dd.MM'
            },
            custom: function({dataPointIndex}) {
                return  '<div>' +
                  '<span class="label">' + t.ecoGradeForFleet + ": " + data[dataPointIndex].eco + '</span>' +
                  '<span class="label">' + t.average + ": " + data[dataPointIndex].srednia_eco + '</span>' +
                  '<span class="label">' + t.kilometers + ": " + data[dataPointIndex].km_eco + '</span>' +
                  '</div>';
              }
        }
    };


    return (
        <div>
            <Chart options={options} series={values(data)} type="line" height={500} />
        </div>
    );
};

ColumnChart.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    data: PropTypes.array
};

export default withTheme(ColumnChart);
